// IncentiveTimeline.jsx
import React from "react";
import "../../styles/initatives.css";
import { ArmyTopIssueContainer } from "./ArmyTopIssueContainer";
import DashboardBarGraph from "../Graph/ArmyGraph";
import { ArmyDataCardContainer } from "./ArmyDataCardContainer";

const incentives = [
  {
    title: "Mental Health First- Aid Workshop",
    date: "August 1, 2025",
    gradient: "#FFDBBB",
  },
  {
    title: "DSM-5-TR Self-Rated Assessment",
    date: "August 14, 2025",
    gradient: "#FFD3AC",
  },
  {
    title: "Screeing Counseling Sessions",
    date: "3rd September, 2025 - 28th September, 2025",
    gradient: "#FBCEB1",
  },
];

const MildHighCounts = [
  {
    category: "Sleep_Problems",
    count: 137,
  },
  {
    category: "Mania",
    count: 84,
  },
  {
    category: "Inattention",
    count: 41,
  },
  {
    category: "Psychosis",
    count: 29,
  },
  {
    category: "Depression",
    count: 17,
  },
  {
    category: "Somatic_Symptoms",
    count: 17,
  },
  {
    category: "Repetitive_Thoughts",
    count: 15,
  },
  {
    category: "Anger",
    count: 15,
  },
  {
    category: "Suicidal_Ideation",
    count: 14,
  },
  {
    category: "Anxiety",
    count: 14,
  },
  {
    category: "Substance_Use",
    count: 4,
  },
];
  





const issuesData = [
  // { category: "Blank", count: 8 },
  { category: "Career prospects", count: 7 },
  { category: "Financial issues", count: 6 },
  { category: "Grief and loss", count: 4 }, 
  { category: "Stress and anxiety", count: 4 },
  { category: "Relationship issues", count: 3 },
  { category: "Self esteem", count: 3 },
  { category: "Family issues", count: 3 },
  { category: "Trauma related", count: 2 },
  { category: "Burnout", count: 1 }, 
  { category: "Anger issues", count: 1 },
  { category: "Substance use", count: 1 }, 
  { category: "Work life balance", count: 1 },
  { category: " Physical health issues", count: 1 },
];
// falgged : 1
// people recommended for further counseling: 72

const Initatives = ({ data }: any) => {
  return (
    /* <div className="timeline-wide-container">
    <h2 className="timeline-wide-header">Incentives & Activities</h2>
    <div className="timeline-wide-list">
      {incentives.map((item, idx) => (
        <div className="timeline-wide-row" key={idx}>
          <div className="timeline-wide-timeline">
            <div className="timeline-wide-dot" />
            {idx !== incentives.length - 1 && (
              <div className="timeline-wide-line" />
            )}
          </div>
          <div
            className="timeline-wide-card"
            style={{ background: item.gradient }}
          >
            <h3 className="timeline-wide-title">{item.title}</h3>
            <p className="timeline-wide-date">Date: {item.date}</p>
          </div>
        </div>
      ))}
    </div>
  </div> */
    <div>
      <h2 className="timeline-header">Initiatives</h2>
      <div className="timeline">
        {/* 1 */}
        <div className="timeline-item">
          {/* <div className="timeline-dot" style={{ background: "#FFDBBB" }} />

          <div className="timeline-line" style={{ background: "#FFDBBB" }} /> */}

          <div style={{ background: "#FFDBBB" }} className={`timeline-content`}>
            <h3 className="item-title">Mental Health First- Aid Workshop</h3>
            <p className="item-date">August 1, 2025</p>
          </div>
        </div>

        {/* 2 */}

        <div className="timeline-item">
          {/* <div className="timeline-dot" style={{ background: "#FFD3AC" }} />

          <div className="timeline-line" style={{ background: "#FFD3AC" }} /> */}

          <div style={{ background: "#FFD3AC" }} className={`timeline-content`}>
            <h3 className="item-title">DSM-5-TR Self-Rated Assessment</h3>
            <p className="item-date">August 14, 2025</p>
          </div>
        </div>
      
        <ArmyTopIssueContainer
          MildHighCounts={MildHighCounts}
          heading={"Top Identified Issues from Assessment"}
        />

        {/* 3 */}

        <div className="timeline-item">
          {/* <div className="timeline-dot" style={{ background: "#FBCEB1" }} /> */}
          {/* {idx !== incentives.length - 1 && (
            <div className="timeline-line" style={{ background: #FBCEB1 }} />
          )} */}
          <div
            style={{ background: "#FBCEB1" }}
            className={`timeline-content last-item`}
          >
            <h3 className="item-title">Screening Counseling Sessions</h3>
            <p className="item-date">
              3rd September, 2025 - 28th September, 2025
            </p>
          </div>
        </div>
              <ArmyDataCardContainer />
        <ArmyTopIssueContainer
          MildHighCounts={issuesData}
          heading={"Identified Issues from Screening Counseling"}
        />

        <DashboardBarGraph data={data} />
      </div>
    </div>
  );
};

export default Initatives;
